import React from 'react';
import './FacultyDashboard.css';
import { useAuth } from '../../AuthContext';
import ClassScheduleTab from './ClassScheduleTab';
import DashboardCalendar from './DashboardCalendar';
import {
  FacultyInfoCard,
  SubjectProgressCard,
  QuickActionsCard,
  CommunicationCard,
  AssignmentTrackerCard,
  QuickNotesCard,
} from './faculty/FacultyDashboardCards';

const FacultyDashboard = () => {
  const { facultyInfo, user, orgId } = useAuth();

  return (
    <div className="fd-dashboard">
      <div className="fd-grid">
        <FacultyInfoCard />
        <SubjectProgressCard />
        <DashboardCalendar orgId={orgId} className="cal-card" maxVisibleEvents={3} />
        <QuickActionsCard />
        <CommunicationCard />
        <AssignmentTrackerCard />
        <ClassScheduleTab selectedUser={user} facultyInfo={facultyInfo} />
        <QuickNotesCard />
      </div>
    </div>
  );
};

export default FacultyDashboard;
